export enum TheatricalRegions {
  US = 'US',
  CA = 'CA',
}
